import toastr from '../vendor/toastr/toastr.js';

type ToastType = 'info' | 'warning' | 'success' | 'error';

interface ToastResponse {
	error?: string;
	warning?: string;
	info?: string;
	success?: string;
}

toastr.options = {
	closeButton: false,
	debug: false,
	newestOnTop: true,
	progressBar: false,
	positionClass: 'toast-top-right',
	preventDuplicates: false,
	onclick: null,
	showDuration: '300000',
	hideDuration: '1000',
	timeOut: '5000',
	extendedTimeOut: '1000',
	showEasing: 'swing',
	hideEasing: 'linear',
	showMethod: 'fadeIn',
	hideMethod: 'fadeOut',
};

const tectoastr = {
	notify(type: ToastType, message: string) {
		const types: ToastType[] = ['info', 'warning', 'success', 'error'];
		type = types.includes(type) ? type : 'info';
		toastr[type](message);
	},

	info(message: string) {
		toastr.info(message);
	},

	warning(message: string, modal = false) {
		if (modal) {
			toastr.options.timeOut = 0;
			toastr.options.extendedTimeOut = 0;
			toastr.options.closeButton = true;
			toastr.options.preventDuplicates = true;
			toastr.options.positionClass = 'toast-bottom-full-width';
		}

		toastr.warning(message);
	},

	success(message: string) {
		toastr.success(message);
	},

	error(message: string) {
		toastr.error(message);
	},

	response(response?: ToastResponse, error?: string) {
		if (response && 'error' in response) {
			toastr.error(response.error!);
		} else if (response && 'warning' in response) {
			toastr.warning(response.warning!);
		} else if (response && 'info' in response) {
			toastr.info(response.info!);
		} else if (response && 'success' in response) {
			toastr.success(response.success!);
		} else {
			toastr.error(error || '');
		}
	},
};

export default tectoastr;
